<template>
  <div class="flex flex-col gap-2 text-base-content/50">
    <div class="grid grid-cols-4 gap-2 justify-center items-center">
      <div v-for="animation in direction1List">
        <img :src="animation.url" alt="frame" crossorigin="anonymous" />
      </div>
    </div>
    <div class="text-center">{{ $t(`Dungeons.sprite.idle`) }}</div>
    <div class="grid grid-cols-4 gap-2 justify-center items-center">
      <div v-for="animation in direction2List">
        <img :src="animation.url" alt="frame" crossorigin="anonymous" />
      </div>
    </div>
    <div class="text-center">{{ $t(`Dungeons.sprite.running`) }}</div>
  </div>
</template>

<script setup lang="ts">
import { MateSpriteAnimation } from "@/types/game";
import { onMounted, PropType, ref } from "vue";

const props = defineProps({
  animations: {
    type: Array as PropType<MateSpriteAnimation[]>,
    required: true,
  },
});

const direction1List = ref<Media[]>([]);
const direction2List = ref<Media[]>([]);

onMounted(() => {
  props.animations.forEach((animation) => {
    if (animation.action === 1) {
      direction1List.value.push(animation.media!);
    } else {
      direction2List.value.push(animation.media!);
    }
  });
});
</script>
